export function adaptStatsBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  const rawStats = entry['stats'] ?? entry['items'];
  const stats = Array.isArray(rawStats)
    ? rawStats.map((s: Record<string, unknown>) => ({
        value: (s['value'] as string) ?? '',
        label: (s['label'] as string) ?? '',
        context: (s['context'] as string) ?? '',
      }))
    : [];

  return { stats };
}
